import { render } from "./named-items.vue?vue&type=template&id=3dd50de6"
import script from "./named-items.vue?vue&type=script&lang=js"
export * from "./named-items.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__